/**
 * Small ISO 4217 currency shortlist for "amount + currency" pickers.
 *
 * The platform is multi-currency (CLAUDE.md §15.2) — every monetary value
 * carries a 3-letter ISO 4217 code. Existing surfaces (rate cards, visit
 * travel cost, contracts) store the code as free text; this shortlist gives
 * a friendlier dropdown while storing the EXACT same 3-letter code, so the
 * data shape is unchanged. Operating currencies are pinned first; extend
 * freely — this is plain data, no logic depends on the length.
 */
export const CURRENCIES = [
    // Pinned — where the business primarily operates / bills.
    'GBP', 'INR', 'USD', 'EUR', 'AED',
    // Broader service-region set.
    'SAR', 'QAR', 'BHD', 'KWD', 'OMR',
    'SGD', 'AUD', 'CAD', 'CHF', 'ZAR',
    'MYR', 'JPY', 'CNY', 'HKD', 'NZD',
];
